import { useCallback, useState } from "react";

export const useAsyncError = (): ((error: unknown) => void) => {
  const [, setError] = useState();
  return useCallback(
    (error) => {
      setError(() => {
        throw error;
      });
    },
    [setError],
  );
};
